// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import DynamicFormDefinitionResourceViewModel from '../../../../viewModel/resource/DynamicFormDefinitionResourceViewModel';
import DynamicFormPayloadResourceViewModel from '../../../../viewModel/resource/DynamicFormPayloadResourceViewModel';
import DigitalDonationReceiptFormDefinitionResourceViewModel from '../../../../viewModel/resource/DigitalDonationReceiptFormDefinitionResourceViewModel';
import DigitalDonationReceiptFormDefinitionResourceDTO from '../../dto/resource/DigitalDonationReceiptFormDefinitionResourceDTO';

export default abstract class DigitalDonationReceiptFormDefinitionResourceModel extends BaseModel<DigitalDonationReceiptFormDefinitionResourceDTO> {
  /**
  */
  get definition() { return this.getObjectModel(() => this.dto.definition, DynamicFormDefinitionResourceViewModel)!; }
  set definition(value) { this.setObjectModel(() => this.dto.definition, value); }
  /**
  */
  get payload() { return this.getObjectModel(() => this.dto.payload, DynamicFormPayloadResourceViewModel)!; }
  set payload(value) { this.setObjectModel(() => this.dto.payload, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
